// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"960":"114275722e7173f4","2106":"9a602e25ab8a3b64"}[chunkId] + ".js";
};